import { appendRedbookImageParams } from "../../helpers/files";
import { RedbookVehiclePhoto } from "../../types/Vehicles";
import ImageCarousel from "./ImageCarousel";

const VehicleImageCarousel = ({
  images,
}: {
  images: RedbookVehiclePhoto[];
}) => {
  return (
    <ImageCarousel
      images={images.map((image) => appendRedbookImageParams(image.href))}
    />
  );
};

export default VehicleImageCarousel;
